import React, { useState, useRef, useEffect } from "react";

import { CloseOutlined } from "@ant-design/icons";
import { Modal } from "react-bootstrap";
import {isMobile } from "react-device-detect";
import ReactPlayer from "react-player";

import { ButtonComponent } from "../../../helper/ReusableComponents";
import { randomNumber } from "../../../helper/service";
import styles from "./PromoSongsComponent.module.css";
const scrollToRef = (ref) => window.scrollTo(0, 200)   
const bandBgColorArr = [
  // "#0D4045",
  // "#A69984",
  // "#A67894",
  // "#776BBE",
  // "#5D9086",
  // "#E47D5E",
  // "#8E9FB0",
  // "#F1557C",
  // "#476A8A",
  // "#1A92D6",
  "#264DA7",
];

export default function PromoSongsComponent({ data }) {
  const reactPlayerRef = useRef(null);

  const [showVideoThumbnail, setShowVideoThumbnail] = useState(true);
  const [selectedChapter, setSelectedChapter] = useState("");

  const [playingVideo, setPlayingVideo] = useState([]);
  const [showModal, setShowModal] = useState(false);

  const [activeband, setActiveband] = useState("");
  const [state, setState] = useState({
    progress: 0,
    duration: 0,
    playing: false,
  });
  const myRef = useRef(null)
  const executeScroll = () => scrollToRef(myRef)
  useEffect(() => {
    let defaultData = data?.filter(e => e?.name?.toLowerCase()?.includes("star power"))
    setActiveband(defaultData?.length> 0 ? defaultData?.[0]?.name : data[0]?.name);
    setPlayingVideo(defaultData?.length> 0 ? defaultData?.[0]?.promoVideo?.[0] : data[0]?.promoVideo[0]);
    setSelectedChapter(defaultData?.length> 0 ? defaultData?.[0]?.promoVideo?.[0]?.chapters?.[0]?._id :data[0]?.promoVideo[0]?.chapters[0]?._id);
  }, [data]);

  /**
   * Handle diffent band type selection
   * @param {object} band
   * @param {string} bandVal
   */
    useEffect(() => {
    let defaultData = data?.filter(e => e?.name?.toLowerCase()?.includes("orchestra"))
    let selBand = defaultData?.length >0 ? defaultData?.[0] : data?.[0] || null
      for (const band of data) {
        if ((band?.promoVideo?.[0]?.chapters?.length || 0) > (selBand?.promoVideo?.[0]?.chapters?.length || 0)) {
          selBand = band
        }
      }
     
    }, [data])

  const onBandSelect = (band, bandVal) => {
     
  
   
    if (bandVal !== activeband) {
      let chapter = band?.promoVideo[0]?.chapters[0];
      setActiveband(bandVal);
      setPlayingVideo(band?.promoVideo[0]);
      setSelectedChapter(chapter?._id);
      handleSeekTo(chapter?.seconds, chapter?._id);
      handlePause();
    }
  };
  const onBandSelectMobile = (band, bandVal) => {

    setShowModal(true);
   
    if (bandVal !== activeband) {
      let chapter = band?.promoVideo[0]?.chapters[0];
      setActiveband(bandVal);
      setPlayingVideo(band?.promoVideo[0]);
      setSelectedChapter(chapter?._id);
      handleSeekTo(chapter?.seconds, chapter?._id);
      handlePause();
    }
  };

  const handlePlayPause = (status) => {
 
    setState({ ...state, playing: status });
  };

  const handlePlay = () => {
    setState({ ...state, playing: true });
    setShowVideoThumbnail(false);
    
  };

  const handlePause = () => {
    setState({ ...state, playing: false });
   
  };

  /**
   * Seek to specfic chapter in video
   * @param {int} value seek time
   * @param {string} chapterId
   */
  const handleSeekTo = (value, chapterId) => {
    setSelectedChapter(chapterId);
    setState({ ...state, playing: true });
    reactPlayerRef.current.seekTo(parseFloat(value));
  };

  const toggleModal = (seekTime, chapterId) => {
    setShowModal(!showModal);
    handleSeekTo(seekTime, chapterId);
  };


  const { playing } = state;

  return (
    <section className={styles.promo_songs_container} id="band-teaser-songlist">
      <div  className="container-fluid">
        <div className="row">
          <div className={`col-lg-4  col-md-0 col-sm-0 col-xs-0 ${styles.promo_songs_songlist_container}`}>
            <div className={styles.promo_songs_list_header}>
              <h2>Promo Songs</h2>
              <p>(Click on any song to cue it up in the video player)</p>
            </div>

            <div className={styles.band_songlist_container}>
              <div>
                {activeband !== "" && (
                  <div className={`d-flex ${styles.band_chapterlist_header}`}>
                    <p>{activeband}</p>
                  </div>
                )}
                {playingVideo &&
                  playingVideo?.chapters?.map((chapter, idx) => (
                    <div
                      key={idx}
                      className={`${styles.band_chapterlist_container} ${
                        chapter._id === selectedChapter ? styles.active : ""
                      }`}
                    >
                      <div
                        className={`d-flex align-items-center ${styles.chapter_thumbnail_wrapper}`}
                        onClick={() =>
                          handleSeekTo(chapter.seconds, chapter._id) 
                        }
                      >
                        <img
                          className={styles.chapter_thumbnail}
                          width={65}
                          height={65}
                          src={process.env.IMAGE_LINK + chapter.thumbnail}
                          alt="chapter-thumbnail"
                        />
                        <p>{chapter.title}</p>
                      </div>
                      {chapter._id === selectedChapter ? (
                        <button className={styles.band_chapter_button}>
                          <img
                            width={28}
                            height={28}
                            src={
                              !playing
                                ? "/assets/images/active_play_icon32.svg"
                                : "/assets/images/active_pause_icon32.svg"
                            }
                            alt="play-icon"
                            onClick={() => handlePlayPause(!playing)}
                          />
                        </button>
                      ) : (
                        <button className={styles.band_chapter_button}>
                          <img
                            width={28}
                            height={28}
                            src="/assets/images/play_icon24.svg"
                            alt="play-icon"
                            onClick={() =>
                              handleSeekTo(chapter.seconds, chapter._id)
                            }
                          />
                        </button>
                      )}
                    </div>
                  ))}
              </div>
            </div>
          </div>

          <div  className={`col-lg-8  col-md-12 col-sm-12 col-xs-12 ${styles.promo_songs_player_container}`}>
            <div ref={myRef}  className={styles.promo_songs_player_wrapper}>
              <ReactPlayer
                ref={reactPlayerRef}
                className={styles.promo_songs_player}
                url={playingVideo?.url}
                key={playingVideo?.url}
                light={
                  showVideoThumbnail && !playing
                    ? `"${process.env.IMAGE_LINK + playingVideo?.thumbnail}"`
                    : false
                }
                playIcon={
                  <img
                    src="/assets/images/play_button.svg"
                    alt="play-icon"
                    onClick={handlePlay}
                  />
                }
                width="100%"
                playing={playing}
                onPlay={handlePlay}
                onPause={handlePause}
                onEnded={() => setShowVideoThumbnail(true)}
                onDuration={(duration) => {
                  setState({ ...state, duration });
                }}
                controls
              />
            </div>

            <div className={styles.promo_songs_filter_wrapper}>
              <h5>Bands</h5>
              <div className={styles.promo_songs_filter_btn_container}>
                {data.length > 0 &&
                  data.map((band, idx) => (
                    <ButtonComponent
                      key={idx}
                      data={{
                        key: idx,
                        type: "button",
                        style: {
                          backgroundColor:
                            bandBgColorArr[
                              randomNumber(0, bandBgColorArr.length)
                            ],
                        },
                        className: `${styles.promo_songs_filter_btn} ${
                          band.name === activeband &&
                          styles.promo_songs_filter_btn_active
                        }`,
                        onClick: () => onBandSelect(band, band.name),
                      }}
                    >
                      {band.name}
                    </ButtonComponent>
                  ))}
              </div>
            </div>
            
            <div className={styles.promo_songs_filter_wrapper_mobile_band}>
              <h5>Bands</h5>
              <div className={styles.promo_songs_filter_btn_container}>
                {data.length > 0 &&
                  data.map((band, idx) => (
                    <ButtonComponent
                      key={idx}
                      data={{
                        key: idx,
                        type: "button",
                        style: {
                          backgroundColor:
                            bandBgColorArr[
                              randomNumber(0, bandBgColorArr.length)
                            ],
                        },
                        className: `${styles.promo_songs_filter_btn} ${
                          band.name === activeband &&
                          styles.promo_songs_filter_btn_active
                        }`,
                        onClick: () => onBandSelectMobile(band, band.name),
                      }}
                    >
                      {band.name}
                    </ButtonComponent>
                  ))}
              </div>
            </div>
          </div>
        </div>
      </div>
    
      <Modal
        centered
        show={showModal}
        contentClassName={ `${styles.promo_songs_songlist_modal_container} 	`}
        onHide={() => setShowModal(false)}
      >
        <Modal.Body>
          <div className={styles.promo_songs_songlist_modal_header}>
            {activeband}
            <CloseOutlined
              className={styles.modal_close}
              onClick={() => setShowModal(false)}
            />
          </div>
          <div className={styles.promo_songs_songlist_modal_body}>
            <div onClick={executeScroll}>
              {playingVideo &&
                playingVideo?.chapters?.map((chapter, idx) => (
                  <div
                    key={idx}
                    className={`${styles.band_chapterlist_modal_container} ${
                      chapter._id === selectedChapter ? styles.active : ""
                    }`}
                    onClick={() => toggleModal(chapter.seconds, chapter._id)}
                  >
                    <div className="d-flex align-items-center">
                      <img
                        className={styles.chapter_thumbnail}
                        width={65}
                        height={65}
                        src={process.env.IMAGE_LINK + chapter.thumbnail}
                        alt="chapter-thumbnail"
                      />
                      <p>{chapter.title}</p>
                    </div>
                  </div>
                ))}
            </div>
          </div>
        </Modal.Body>
      </Modal>
   

    </section>
    
  );
}
